import { createContext, useState } from "react";
import PropTypes from "prop-types";
import { getUserData } from "./utils/utils";

const AuthorizationContext = createContext();

const AuthorizationProvider = ({ children }) => {
  const storedRole = getUserData()?.role ?? 0;
  const [userRole, setUserRole] = useState(storedRole);

  const setUserAuthorization = (role) => {
    setUserRole(role);
  };

  return (
    <AuthorizationContext.Provider value={{ userRole, setUserAuthorization }}>
      {children}
    </AuthorizationContext.Provider>
  );
};

AuthorizationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { AuthorizationContext, AuthorizationProvider };
